import {
  type ConversationFilter,
  type ConversationId,
  type ConversationListInput,
  type ConversationSortBy,
  type ConversationSortOrder,
} from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const conversationKey = (conversationId: ConversationId): QueryKey => ['conversation', conversationId]
export const conversationCategoriesKey = (): QueryKey => ['conversation-categories']
export const conversationsKey = (input?: ConversationListInput): QueryKey => {
  if (!input) return ['conversations']
  return ['conversations', input]
}
export const conversationsInfiniteKey = (
  filter?: ConversationFilter,
  sortBy?: ConversationSortBy,
  sortOrder?: ConversationSortOrder,
): QueryKey => ['conversations-infinite', filter, sortBy, sortOrder]
export const conversationShareableKey = (category: string): QueryKey => ['conversation-shareable', category]
